<template>
  <CardedDisplay>
    <PlainDisplay
      icon="mdi-help-circle-outlin"
      title="Get in touch with us, for any questions and Inquiries"
    >
      <ContactInLineDisplay
        v-for="(contact, index) in page_contacts"
        :key="index"
        :icon="contact.icon"
        :label="contact.label"
        :value="contact.value"
        :remark="contact.remark"
        :protocol="contact.protocol"
      ></ContactInLineDisplay>
    </PlainDisplay>
    <v-divider></v-divider>
    <PlainDisplay icon="mdi-account-group" title="Find us on social media :">
        <v-btn
        small
        rounded
        class="mr-4 float-right"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' + business.id + '/contacts/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Contact Info
      </v-btn>
      <ContactInLineDisplay
        v-for="(contact, index) in page_social_media_links"
        :key="index"
        :icon="contact.icon"
        :label="contact.label"
        :value="contact.value"
        :remark="contact.remark"
        :protocol="contact.protocol"
      ></ContactInLineDisplay>
    </PlainDisplay>
  </CardedDisplay>
</template>

<script>
import Utils from "./../lib/Utils";
import CardedDisplay from "./../components/CardedDisplay";
import PlainDisplay from "./../components/PlainDisplay";
import ContactInLineDisplay from "./../components/ContactInLineDisplay";
import RedText from "./../components/RedText";
export default {
  name: "BusinessViewContacts",
  components: {
    CardedDisplay,
    PlainDisplay,
    ContactInLineDisplay,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    page_contacts() {
      var lst = [];
      if (this.business) {
        lst.push({
          icon: "mdi-phone-classic",
          label: "Officce Line:",
          value: this.business.office_phone_number1,
          remark: "",
          protocol: "tel:",
        });
        lst.push({
          icon: "mdi-cellphone-basic",
          label: "Mobile Number:",
          value: this.business.mobile_phone_number1,
          remark: "",
          protocol: "tel:",
        });
        lst.push({
          icon: "mdi-fax",
          label: "Fax :",
          value: this.business.fax_number,
          remark: "",
          protocol: "fax:",
        });
        lst.push({
          icon: "mdi-send",
          label: "Box Number:",
          value: this.business.pobox_number,
          remark: "",
          protocol: "",
        });
        lst.push({
          icon: "mdi-email-variant",
          label: "Email Address :",
          value: this.business.email_address_1,
          remark: "",
          protocol: "mailto:",
        });
        lst.push({
          icon: "mdi-earth",
          label: "Website :",
          value: this.business.website_1,
          remark: "",
          protocol: "",
        });
      }
      return lst;
    },
    page_social_media_links() {
      var lst = [];
      if (this.business) {
        lst = [
          {
            icon: "mdi-facebook",
            label: "Facebook:",
            value: this.business.facebook_link,
            remark: "",
            protocol: "",
          },
          {
            icon: "mdi-whatsapp",
            label: "Whatsapp:",
            value: this.business.whatsapp_link,
            remark: "",
            protocol: "tel:",
          },
          {
            icon: "mdi-twitter",
            label: "Twitter:",
            value: this.business.twitter_link,
            remark: "",
            protocol: "",
          },
          {
            icon: "mdi-instagram",
            label: "Instagram:",
            value: this.business.instagram_link,
            remark: "",
            protocol: "",
          },
          {
            icon: "mdi-youtube",
            label: "Youtube:",
            value: this.business.youtube_link,
            remark: "",
            protocol: "",
          },
          {
            icon: "mdi-linkedin",
            label: "LinkedIn:",
            value: this.business.linked_link,
            remark: "",
            protocol: "",
          },
        ];
      }
      return lst;
    },
  },
};
</script>